require("./bootstrap");
import 'select2';
import 'gridstack/dist/gridstack.min.css';
import { GridStack } from 'gridstack';
window.GridStack = GridStack;

